import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=2236eaea&"
import script from "./CouponList.vue?vue&type=script&lang=js&"
export * from "./CouponList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports